import type {
  DeleteApiAlbumCollectionsIdPathParams,
  PostApiAlbumCollectionsMutationRequest,
  PutApiAlbumCollectionsIdMutationRequest,
  PutApiAlbumCollectionsIdPathParams,
} from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'

import {
  albumCollectionAddAlbum,
  albumCollectionByIdQuery,
  albumCollectionCreate,
  albumCollectionDelete,
  albumCollectionDeleteAlbum,
  albumCollectionOrderAlbums,
  albumCollectionUpdate,
} from '../api'

// By Id

interface AlbumCollectionGateProps {
  id: string
}
export const AlbumCollectionGate = createGate<AlbumCollectionGateProps>()
export const albumCollectionByIdRefreshed = createEvent()
sample({
  clock: [AlbumCollectionGate.open],
  fn: ({ id }: AlbumCollectionGateProps) => ({ id }),
  target: albumCollectionByIdQuery.start,
})

sample({
  source: AlbumCollectionGate.state,
  clock: albumCollectionByIdRefreshed,
  target: albumCollectionByIdQuery.start,
})

sample({
  clock: AlbumCollectionGate.close,
  target: albumCollectionByIdQuery.reset,
})

sample({
  clock: [
    albumCollectionAddAlbum.finished.success,
    albumCollectionDeleteAlbum.finished.success,
    albumCollectionOrderAlbums.finished.success,
  ],
  target: albumCollectionByIdRefreshed,
})

sample({
  clock: albumCollectionAddAlbum.finished.success,
  fn: () => {
    return {
      message: 'Сезон прикреплен к выпуску',
    }
  },
  target: showNotificationSuccessFx,
})

sample({
  clock: albumCollectionOrderAlbums.finished.success,
  fn: () => {
    return {
      message: 'Порядок сезонов обновлён',
    }
  },
  target: showNotificationSuccessFx,
})

sample({
  clock: albumCollectionDeleteAlbum.finished.success,
  fn: () => {
    return {
      message: 'Сезон откреплен от выпуска',
    }
  },
  target: showNotificationSuccessFx,
})

// Create

export const albumCollectionSubmitted =
  createEvent<PostApiAlbumCollectionsMutationRequest>()
sample({
  clock: albumCollectionSubmitted,
  fn: (data) => ({ data }),
  target: [albumCollectionCreate.start],
})

sample({
  clock: albumCollectionCreate.finished.success,
  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

// Edit

export const albumCollectionEdited = createEvent<{
  id: PutApiAlbumCollectionsIdPathParams['Id']
  data: PutApiAlbumCollectionsIdMutationRequest
}>()
sample({
  clock: albumCollectionEdited,
  fn: ({ id, data }) => ({ id, data }),
  target: [albumCollectionUpdate.start],
})

sample({
  clock: albumCollectionUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})
// Delete

export const albumCollectionDeleted = createEvent<{
  id: DeleteApiAlbumCollectionsIdPathParams['Id']
}>()

sample({
  clock: albumCollectionDeleted,
  fn: ({ id }) => ({ id }),
  target: [albumCollectionDelete.start],
})

sample({
  clock: albumCollectionDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})
